import { render, staticRenderFns } from "./SecondBar.vue?vue&type=template&id=16c24781&scoped=true&"
import script from "./SecondBar.vue?vue&type=script&lang=js&"
export * from "./SecondBar.vue?vue&type=script&lang=js&"
import style0 from "./SecondBar.vue?vue&type=style&index=0&id=16c24781&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c24781",
  null
  
)

export default component.exports